type Scope<T> = T extends () => infer U
  ? Scope<U> | { [K in keyof T]: Scope<T[K]> }[keyof T]
  : T extends { [K in string]: infer U }
    ? Scope<U>
    : T extends string
      ? T
      : never

export type CandidateViewPermissionScope = Scope<typeof scopes>

export type CandidateViewRootPermissionScope = keyof typeof scopes

export const scopes = {
  biography: Object.assign(() => 'biography' as const, {
    description: () => 'biography/description' as const,
    employmentStatus: () => 'biography/employmentStatus' as const,
    experience: () => 'biography/experience' as const,
    fullName: () => 'biography/fullName' as const,
    homeCountry: () => 'biography/homeCountry' as const,
    homeMunicipality: () => 'biography/homeMunicipality' as const,
    profession: () => 'biography/profession' as const,
    qualifications: Object.assign(() => 'biography/qualifications' as const, {
      driversLicense: () => 'biography/qualifications/driversLicense' as const,
      journalSystems: () => 'biography/qualifications/journalSystems' as const,
      licenseStatuses: () =>
        'biography/qualifications/licenseStatuses' as const,
      specializations: () =>
        'biography/qualifications/specializations' as const,
    }),
  }),
  candidate: () => 'candidate' as const,
  contactRequests: () => 'contactRequests' as const,
  fileUploads: () => 'fileUploads' as const,
  information: Object.assign(() => 'information' as const, {
    email: () => 'information/email' as const,
    personalIdentityNumber: () => 'information/personalIdentityNumber' as const,
    phoneNumber: () => 'information/phoneNumber' as const,
    hpr: () => 'information/hpr' as const,
    graduatedAt: () => 'information/graduatedAt' as const,
  }),
  interests: Object.assign(() => 'interests' as const, {
    contactPreferences: Object.assign(
      () => 'interests/contactPreferences' as const,
      {
        isInterestedInContact: () =>
          'interests/contactPreferences/isInterestedInContact' as const,
        isInterestedInMatchingVacancies: () =>
          'interests/contactPreferences/isInterestedInMatchingVacancies' as const,
      },
    ),
    countries: () => 'interests/countries' as const,
    departments: () => 'interests/departments' as const,
    extent: () => 'interests/extent' as const,
    jobTypes: () => 'interests/jobTypes' as const,
    municipalities: () => 'interests/municipalities' as const,
    regions: () => 'interests/regions' as const,
    startDate: () => 'interests/startDate' as const,
    workForms: () => 'interests/workForms' as const,
  }),
  profileProgress: () => 'profileProgress' as const,
  references: () => 'references' as const,
  vacancies: () => 'vacancies' as const,
  contract: () => 'contract' as const, // TODO: split this up into subscopes?
}
